<div class="p-otp-input" [class.p-otp-input--error]="hasError" role="group">
    <input
        *ngFor="let index of indexes; trackBy: trackByIndex"
        #box
        class="p-otp-input__box p-heading-1"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="1"
        [attr.aria-label]="'digit ' + (index + 1)"
        [attr.automation-id]="'otp_digit_' + index"
        [value]="digits[index]"
        [disabled]="isDisabled"
        (input)="onInput(index, $event)"
        (keydown)="onKeydown(index, $event)"
        (paste)="onPaste($event)"
        (blur)="onTouched()"
    />
</div>
